/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CreateCurriculumDocumentRequestInput,
  CurriculumCategoryLabelsIndex,
  CurriculumDocument,
  CurriculumDocumentKindsIndex,
  CurriculumDocumentsIndex,
  CurriculumLibraryDefaults,
  CurriculumLibraryDocumentOutline,
  CurriculumLibraryDocumentsIndex,
  CurriculumLibrarySearchResult,
  CurriculumLibrarySectionsIndex,
  CurriculumLocationsIndex,
  CurriculumMatch,
  GetCurriculumMatchesParams,
  ListCurriculumCategoryLabelsParams,
  ListCurriculumDocumentsParams,
  ListCurriculumLibraryDocumentSectionsParams,
  ListCurriculumLibraryDocumentsParams,
  SchemaValidationErrorResponse,
  SearchCurriculumLibrarySectionsParams,
  UpdateCurriculumDocumentRequestInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List curriculum category labels
 */
export const listCurriculumCategoryLabels = (
    params?: MaybeRefOrGetter<ListCurriculumCategoryLabelsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CurriculumCategoryLabelsIndex>(
      {url: `/curriculum/category_labels`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCurriculumCategoryLabelsQueryKey = (params?: MaybeRefOrGetter<ListCurriculumCategoryLabelsParams>,) => {
    return [
    'curriculum','category_labels', ...(params ? [params] : [])
    ] as const;
    }


export const getListCurriculumCategoryLabelsQueryOptions = <TData = Awaited<ReturnType<typeof listCurriculumCategoryLabels>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListCurriculumCategoryLabelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumCategoryLabels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCurriculumCategoryLabelsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurriculumCategoryLabels>>> = ({ signal }) => listCurriculumCategoryLabels(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurriculumCategoryLabels>>, TError, TData>
}

export type ListCurriculumCategoryLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurriculumCategoryLabels>>>
export type ListCurriculumCategoryLabelsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List curriculum category labels
 */

export function useListCurriculumCategoryLabels<TData = Awaited<ReturnType<typeof listCurriculumCategoryLabels>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListCurriculumCategoryLabelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumCategoryLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurriculumCategoryLabelsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List curriculum document kinds
 */
export const listCurriculumDocumentKinds = (

 signal?: AbortSignal
) => {


      return axiosClient<CurriculumDocumentKindsIndex>(
      {url: `/curriculum/document_kinds`, method: 'GET', signal
    },
      );
    }




export const getListCurriculumDocumentKindsQueryKey = () => {
    return [
    'curriculum','document_kinds'
    ] as const;
    }


export const getListCurriculumDocumentKindsQueryOptions = <TData = Awaited<ReturnType<typeof listCurriculumDocumentKinds>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumDocumentKinds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCurriculumDocumentKindsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurriculumDocumentKinds>>> = ({ signal }) => listCurriculumDocumentKinds(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurriculumDocumentKinds>>, TError, TData>
}

export type ListCurriculumDocumentKindsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurriculumDocumentKinds>>>
export type ListCurriculumDocumentKindsQueryError = ErrorType<void>


/**
 * @summary List curriculum document kinds
 */

export function useListCurriculumDocumentKinds<TData = Awaited<ReturnType<typeof listCurriculumDocumentKinds>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumDocumentKinds>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurriculumDocumentKindsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create uploaded curriculum document
 */
export const createCurriculumDocument = (
    createCurriculumDocumentRequestInput: MaybeRefOrGetter<CreateCurriculumDocumentRequestInput>,
 signal?: AbortSignal
) => {
      createCurriculumDocumentRequestInput = toValue(createCurriculumDocumentRequestInput);

      return axiosClient<CurriculumDocument>(
      {url: `/curriculum/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCurriculumDocumentRequestInput, signal
    },
      );
    }




export const getCreateCurriculumDocumentMutationKey = () => ['createCurriculumDocument'] as const;

export const getCreateCurriculumDocumentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCurriculumDocument>>, TError,CreateCurriculumDocumentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCurriculumDocument>>, TError,CreateCurriculumDocumentMutationVariables, TContext> => {

const mutationKey = getCreateCurriculumDocumentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCurriculumDocument>>, CreateCurriculumDocumentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCurriculumDocument(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCurriculumDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createCurriculumDocument>>>
    export type CreateCurriculumDocumentMutationBody = CreateCurriculumDocumentRequestInput
    export type CreateCurriculumDocumentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateCurriculumDocumentMutationVariables = {data: CreateCurriculumDocumentRequestInput}

    /**
 * @summary Create uploaded curriculum document
 */
export const useCreateCurriculumDocument = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCurriculumDocument>>, TError,CreateCurriculumDocumentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCurriculumDocument>>,
        TError,
        CreateCurriculumDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCurriculumDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary List uploaded curriculum documents
 */
export const listCurriculumDocuments = (
    params?: MaybeRefOrGetter<ListCurriculumDocumentsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CurriculumDocumentsIndex>(
      {url: `/curriculum/documents`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCurriculumDocumentsQueryKey = (params?: MaybeRefOrGetter<ListCurriculumDocumentsParams>,) => {
    return [
    'curriculum','documents', ...(params ? [params] : [])
    ] as const;
    }


export const getListCurriculumDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listCurriculumDocuments>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListCurriculumDocumentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCurriculumDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurriculumDocuments>>> = ({ signal }) => listCurriculumDocuments(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurriculumDocuments>>, TError, TData>
}

export type ListCurriculumDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurriculumDocuments>>>
export type ListCurriculumDocumentsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List uploaded curriculum documents
 */

export function useListCurriculumDocuments<TData = Awaited<ReturnType<typeof listCurriculumDocuments>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListCurriculumDocumentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurriculumDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete uploaded curriculum document
 */
export const deleteCurriculumDocument = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/curriculum/documents/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteCurriculumDocumentMutationKey = () => ['deleteCurriculumDocument'] as const;

export const getDeleteCurriculumDocumentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCurriculumDocument>>, TError,DeleteCurriculumDocumentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCurriculumDocument>>, TError,DeleteCurriculumDocumentMutationVariables, TContext> => {

const mutationKey = getDeleteCurriculumDocumentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCurriculumDocument>>, DeleteCurriculumDocumentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteCurriculumDocument(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCurriculumDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCurriculumDocument>>>

    export type DeleteCurriculumDocumentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteCurriculumDocumentMutationVariables = {id: string}

    /**
 * @summary Delete uploaded curriculum document
 */
export const useDeleteCurriculumDocument = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCurriculumDocument>>, TError,DeleteCurriculumDocumentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCurriculumDocument>>,
        TError,
        DeleteCurriculumDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCurriculumDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Update uploaded curriculum document
 */
export const updateCurriculumDocument = (
    id: MaybeRefOrGetter<string>,
    updateCurriculumDocumentRequestInput: MaybeRefOrGetter<UpdateCurriculumDocumentRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
updateCurriculumDocumentRequestInput = toValue(updateCurriculumDocumentRequestInput);

      return axiosClient<CurriculumDocument>(
      {url: `/curriculum/documents/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCurriculumDocumentRequestInput, signal
    },
      );
    }




export const getUpdateCurriculumDocumentMutationKey = () => ['updateCurriculumDocument'] as const;

export const getUpdateCurriculumDocumentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurriculumDocument>>, TError,UpdateCurriculumDocumentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCurriculumDocument>>, TError,UpdateCurriculumDocumentMutationVariables, TContext> => {

const mutationKey = getUpdateCurriculumDocumentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCurriculumDocument>>, UpdateCurriculumDocumentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateCurriculumDocument(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCurriculumDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateCurriculumDocument>>>
    export type UpdateCurriculumDocumentMutationBody = UpdateCurriculumDocumentRequestInput
    export type UpdateCurriculumDocumentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdateCurriculumDocumentMutationVariables = {id: string;data: UpdateCurriculumDocumentRequestInput}

    /**
 * @summary Update uploaded curriculum document
 */
export const useUpdateCurriculumDocument = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurriculumDocument>>, TError,UpdateCurriculumDocumentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCurriculumDocument>>,
        TError,
        UpdateCurriculumDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCurriculumDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Where the curriculum library opens for the viewer
 */
export const getCurriculumLibraryDefaults = (

 signal?: AbortSignal
) => {


      return axiosClient<CurriculumLibraryDefaults>(
      {url: `/curriculum/library/defaults`, method: 'GET', signal
    },
      );
    }




export const getGetCurriculumLibraryDefaultsQueryKey = () => {
    return [
    'curriculum','library','defaults'
    ] as const;
    }


export const getGetCurriculumLibraryDefaultsQueryOptions = <TData = Awaited<ReturnType<typeof getCurriculumLibraryDefaults>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurriculumLibraryDefaults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCurriculumLibraryDefaultsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurriculumLibraryDefaults>>> = ({ signal }) => getCurriculumLibraryDefaults(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurriculumLibraryDefaults>>, TError, TData>
}

export type GetCurriculumLibraryDefaultsQueryResult = NonNullable<Awaited<ReturnType<typeof getCurriculumLibraryDefaults>>>
export type GetCurriculumLibraryDefaultsQueryError = ErrorType<void>


/**
 * @summary Where the curriculum library opens for the viewer
 */

export function useGetCurriculumLibraryDefaults<TData = Awaited<ReturnType<typeof getCurriculumLibraryDefaults>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurriculumLibraryDefaults>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurriculumLibraryDefaultsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List curriculum documents in a filter frame, with facet counts
 */
export const listCurriculumLibraryDocuments = (
    params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CurriculumLibraryDocumentsIndex>(
      {url: `/curriculum/library/documents`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCurriculumLibraryDocumentsQueryKey = (params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentsParams>,) => {
    return [
    'curriculum','library','documents', ...(params ? [params] : [])
    ] as const;
    }


export const getListCurriculumLibraryDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listCurriculumLibraryDocuments>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLibraryDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCurriculumLibraryDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurriculumLibraryDocuments>>> = ({ signal }) => listCurriculumLibraryDocuments(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLibraryDocuments>>, TError, TData>
}

export type ListCurriculumLibraryDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurriculumLibraryDocuments>>>
export type ListCurriculumLibraryDocumentsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List curriculum documents in a filter frame, with facet counts
 */

export function useListCurriculumLibraryDocuments<TData = Awaited<ReturnType<typeof listCurriculumLibraryDocuments>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLibraryDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurriculumLibraryDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary The text of a curriculum document's sections, whole or one chapter
 */
export const listCurriculumLibraryDocumentSections = (
    documentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentSectionsParams>,
 signal?: AbortSignal
) => {
      documentId = toValue(documentId);
params = toValue(params);

      return axiosClient<CurriculumLibrarySectionsIndex>(
      {url: `/curriculum/library/documents/${documentId}/sections`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCurriculumLibraryDocumentSectionsQueryKey = (documentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentSectionsParams>,) => {
    return [
    'curriculum','library','documents',documentId,'sections', ...(params ? [params] : [])
    ] as const;
    }


export const getListCurriculumLibraryDocumentSectionsQueryOptions = <TData = Awaited<ReturnType<typeof listCurriculumLibraryDocumentSections>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(documentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentSectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLibraryDocumentSections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCurriculumLibraryDocumentSectionsQueryKey(documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurriculumLibraryDocumentSections>>> = ({ signal }) => listCurriculumLibraryDocumentSections(documentId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(documentId) !== null && toValue(documentId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLibraryDocumentSections>>, TError, TData>
}

export type ListCurriculumLibraryDocumentSectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurriculumLibraryDocumentSections>>>
export type ListCurriculumLibraryDocumentSectionsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary The text of a curriculum document's sections, whole or one chapter
 */

export function useListCurriculumLibraryDocumentSections<TData = Awaited<ReturnType<typeof listCurriculumLibraryDocumentSections>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 documentId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListCurriculumLibraryDocumentSectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLibraryDocumentSections>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurriculumLibraryDocumentSectionsQueryOptions(documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary A curriculum document with its outline
 */
export const getCurriculumLibraryDocument = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<CurriculumLibraryDocumentOutline>(
      {url: `/curriculum/library/documents/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetCurriculumLibraryDocumentQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'curriculum','library','documents',id
    ] as const;
    }


export const getGetCurriculumLibraryDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getCurriculumLibraryDocument>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurriculumLibraryDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCurriculumLibraryDocumentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurriculumLibraryDocument>>> = ({ signal }) => getCurriculumLibraryDocument(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurriculumLibraryDocument>>, TError, TData>
}

export type GetCurriculumLibraryDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getCurriculumLibraryDocument>>>
export type GetCurriculumLibraryDocumentQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary A curriculum document with its outline
 */

export function useGetCurriculumLibraryDocument<TData = Awaited<ReturnType<typeof getCurriculumLibraryDocument>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurriculumLibraryDocument>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurriculumLibraryDocumentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search the sections of curriculum documents
 */
export const searchCurriculumLibrarySections = (
    params: MaybeRefOrGetter<SearchCurriculumLibrarySectionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CurriculumLibrarySearchResult>(
      {url: `/curriculum/library/sections`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchCurriculumLibrarySectionsQueryKey = (params?: MaybeRefOrGetter<SearchCurriculumLibrarySectionsParams>,) => {
    return [
    'curriculum','library','sections', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCurriculumLibrarySectionsQueryOptions = <TData = Awaited<ReturnType<typeof searchCurriculumLibrarySections>>, TError = ErrorType<void>>(params: MaybeRefOrGetter<SearchCurriculumLibrarySectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCurriculumLibrarySections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchCurriculumLibrarySectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCurriculumLibrarySections>>> = ({ signal }) => searchCurriculumLibrarySections(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCurriculumLibrarySections>>, TError, TData>
}

export type SearchCurriculumLibrarySectionsQueryResult = NonNullable<Awaited<ReturnType<typeof searchCurriculumLibrarySections>>>
export type SearchCurriculumLibrarySectionsQueryError = ErrorType<void>


/**
 * @summary Search the sections of curriculum documents
 */

export function useSearchCurriculumLibrarySections<TData = Awaited<ReturnType<typeof searchCurriculumLibrarySections>>, TError = ErrorType<void>>(
 params: MaybeRefOrGetter<SearchCurriculumLibrarySectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCurriculumLibrarySections>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCurriculumLibrarySectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List curriculum countries and regions
 */
export const listCurriculumLocations = (

 signal?: AbortSignal
) => {


      return axiosClient<CurriculumLocationsIndex>(
      {url: `/curriculum/locations`, method: 'GET', signal
    },
      );
    }




export const getListCurriculumLocationsQueryKey = () => {
    return [
    'curriculum','locations'
    ] as const;
    }


export const getListCurriculumLocationsQueryOptions = <TData = Awaited<ReturnType<typeof listCurriculumLocations>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLocations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCurriculumLocationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurriculumLocations>>> = ({ signal }) => listCurriculumLocations(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLocations>>, TError, TData>
}

export type ListCurriculumLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurriculumLocations>>>
export type ListCurriculumLocationsQueryError = ErrorType<void>


/**
 * @summary List curriculum countries and regions
 */

export function useListCurriculumLocations<TData = Awaited<ReturnType<typeof listCurriculumLocations>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurriculumLocations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurriculumLocationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Curriculum documents matching a teacher's profile or a material's categories
 */
export const getCurriculumMatches = (
    params: MaybeRefOrGetter<GetCurriculumMatchesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CurriculumMatch>(
      {url: `/curriculum/matches`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetCurriculumMatchesQueryKey = (params?: MaybeRefOrGetter<GetCurriculumMatchesParams>,) => {
    return [
    'curriculum','matches', ...(params ? [params] : [])
    ] as const;
    }


export const getGetCurriculumMatchesQueryOptions = <TData = Awaited<ReturnType<typeof getCurriculumMatches>>, TError = ErrorType<void>>(params: MaybeRefOrGetter<GetCurriculumMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurriculumMatches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCurriculumMatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurriculumMatches>>> = ({ signal }) => getCurriculumMatches(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurriculumMatches>>, TError, TData>
}

export type GetCurriculumMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof getCurriculumMatches>>>
export type GetCurriculumMatchesQueryError = ErrorType<void>


/**
 * @summary Curriculum documents matching a teacher's profile or a material's categories
 */

export function useGetCurriculumMatches<TData = Awaited<ReturnType<typeof getCurriculumMatches>>, TError = ErrorType<void>>(
 params: MaybeRefOrGetter<GetCurriculumMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurriculumMatches>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurriculumMatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






